module.exports = __webpack_public_path__ + "static/media/imgClient.6d8b5c1c.svg";